import React from 'react';
import {makeStyles, useTheme} from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import {useHistory} from 'react-router-dom';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Hidden from '@material-ui/core/Hidden';
import Link from '@material-ui/core/Link';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import Fab from '@material-ui/core/Fab';
import Zoom from '@material-ui/core/Zoom';
import ScrollAnimation from 'react-animate-on-scroll';

import PinterestIcon from '@material-ui/icons/Pinterest';
import InstagramIcon from '@material-ui/icons/Instagram';
import FacebookIcon from '@material-ui/icons/Facebook';
import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined';
import MailOutlineOutlinedIcon from '@material-ui/icons/MailOutlineOutlined';
import SmartphoneOutlinedIcon from '@material-ui/icons/SmartphoneOutlined';
import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';

import hero from '../assets/images/hero.jpg';
import logo from '../assets/logo.png';

const useStyles = makeStyles(theme => ({
    heroImage: {
        position: "relative",
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.25)), url(${hero})`,
        height: '100vh',
        minHeight: '600px',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        zIndex: 1
    },
    container: {
        paddingLeft: "15%",
        paddingRight: "15%",
        [theme.breakpoints.down("sm")]: {
            paddingLeft: "5%",
            paddingRight: "5%",
        },
    },
    topBar: {
        borderBottom: "1px solid #cccccc55",
    },
    topBarText: {
        color: theme.palette.common.white,
        fontSize: "0.9rem",
        fontWeight: "bold",
        [theme.breakpoints.down("md")]: {
            fontSize: "0.8rem",
        },
    },
    topBarIcon: {
        color: theme.palette.common.white,
        fontSize: "1.5rem",
        [theme.breakpoints.down("md")]: {
            fontSize: "1.4rem",
        },
    },
    logoImage: {
        width: 110,
        userSelect: "none",
        [theme.breakpoints.down("md")]: {
            width: 90
        },
        [theme.breakpoints.down("sm")]: {
            width: 90
        },
        [theme.breakpoints.down("xs")]: {
            width: 70,
        },
    },
    logoTitle: {
        textTransform: "uppercase",
        [theme.breakpoints.down("md")]: {
            fontSize: "25px",
        },
        [theme.breakpoints.down("sm")]: {
            fontSize: "30px",
        },
        [theme.breakpoints.down("xs")]: {
            fontSize: "20px",
        },
    },
    logoSubtitle: {
        textTransform: "uppercase",
        [theme.breakpoints.down("md")]: {
            fontSize: "9.5px",
        },
        [theme.breakpoints.down("sm")]: {
            fontSize: "12px",
        },
        [theme.breakpoints.down("xs")]: {
            fontSize: "8px",
        },
    },
    menu: {
        cursor: "pointer",
        color: "#ccc",
        transition: "0.5s",
        "&:hover": {
            color: theme.palette.primary.main,
        }
    },
    heroTitle: {
        fontSize: "4rem",
        color: theme.palette.common.white,
        lineHeight: 1,
        [theme.breakpoints.down("md")]: {
            fontSize: "3.5rem",
        },
        [theme.breakpoints.down("sm")]: {
            fontSize: "2.5rem",
        },
        [theme.breakpoints.down("xs")]: {
            fontSize: "1.5rem",
        },
    },

    heroSubtitle: {
        fontSize: "2rem",
        color: theme.palette.common.white,
        lineHeight: 1,
        [theme.breakpoints.down("md")]: {
            fontSize: "1.5rem",
        },
        [theme.breakpoints.down("sm")]: {
            fontSize: "1rem",
        },
        [theme.breakpoints.down("xs")]: {
            fontSize: "1rem",
        },
    },
    instagram: {
        cursor: "pointer",
        transition: "0.5s",
        "&:hover": {
            color: "#e4405f",
        }
    },
    facebook: {
        cursor: "pointer",
        transition: "0.5s",
        "&:hover": {
            color: "#3b5999",
        }
    },
    pinterest: {
        cursor: "pointer",
        transition: "0.5s",
        "&:hover": {
            color: "#bd081c",
        }
    },
    root: {
        position: 'fixed',
        bottom: theme.spacing(4),
        right: theme.spacing(4),
    },
    menuSelected: {
        color: theme.palette.primary.main,
        fontWeight: "bold"
    },
}))

function ScrollTop(props) {
    const {children, window} = props;
    const classes = useStyles();
    // Note that you normally won't need to set the window ref as useScrollTrigger
    // will default to window.
    // This is only being set here because the demo is in an iframe.
    const trigger = useScrollTrigger({
        target: window ? window() : undefined,
        disableHysteresis: true,
        threshold: 100,
    });

    const handleClick = (event) => {
        const anchor = (event.target.ownerDocument || document).querySelector('#home');

        if (anchor) {
            anchor.scrollIntoView({behavior: 'smooth', block: 'start'});
        }
    };

    return (
        <Zoom in={trigger}>
            <div onClick={handleClick} role="presentation" className={classes.root}>
                {children}
            </div>
        </Zoom>
    );
}

export default function Header(props) {
    const classes = useStyles();
    const theme = useTheme();
    const history = useHistory();
    const matchesMD = useMediaQuery(theme.breakpoints.down("md"));
    const matchesSM = useMediaQuery(theme.breakpoints.down("sm"));
    const matchesXS = useMediaQuery(theme.breakpoints.down("xs"));


    const menuSelected = props.menuSelected;
    const setMenuSelected = props.setMenuSelected;

    const homeLink = () => {
        setMenuSelected("home");
    };
    const servicesLink = () => {
        setMenuSelected("services");
    };
    const projectsLink = () => {
        setMenuSelected("projects");
    };
    const aboutLink = () => {
        setMenuSelected("about");
    };
    const contactLink = () => {
        setMenuSelected("contact");
    };

    return (
        <React.Fragment>
            <div className={classes.heroImage} id="home">
                {/* Scroll Top */}
                <ScrollTop>
                    <Fab color="primary" size="small" aria-label="scroll back to top" style={{
                        borderRadius: 0,
                        clipPath: "polygon(0% 50%, 50% 0%, 100% 50%, 100% 100%, 0% 100%)",

                    }}>
                        <MeetingRoomIcon style={{marginTop: "21px"}}/>
                    </Fab>
                </ScrollTop>

                {/* { Top bar } */}
                <Hidden smDown>
                    <div className={classes.topBar}>
                        <Grid container className={classes.container}>
                            <Grid item container direction="row" justify="space-between" alignItems="center">
                                <Grid item>
                                    <Grid item container direction="row" alignItems="center" spacing={2}>

                                        <Grid item>
                                            <Grid item container direction="row" alignItems="center" spacing={1}>
                                                <Grid item>
                                                    <LocationOnOutlinedIcon className={classes.topBarIcon}/>
                                                </Grid>
                                                <Grid item>
                                                    <Typography variant="subtitle1" className={classes.topBarText}>
                                                        9446 Onion Patch Drive <br/> Burke, Virginia 22015
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid item>
                                            <Grid item container direction="row" alignItems="center" spacing={1}>
                                                <Grid item>
                                                    <MailOutlineOutlinedIcon className={classes.topBarIcon}/>
                                                </Grid>
                                                <Grid item>
                                                    <Typography variant="subtitle1" className={classes.topBarText}>
                                                        TechnoConstruction1@gmail.com
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid item>
                                            <Grid item container direction="row" alignItems="center" spacing={1}>
                                                <Grid item>
                                                    <SmartphoneOutlinedIcon className={classes.topBarIcon}/>
                                                </Grid>
                                                <Grid item>
                                                    <Typography variant="subtitle1" className={classes.topBarText}
                                                                style={{lineHeight: 1.2}}>
                                                        +1 (703) 929-6163
                                                        <br/>
                                                        +1 (202) 909-6603
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                    </Grid>
                                </Grid>
                                <Grid item>
                                    <Grid item container direction="row" alignItems="center" spacing={2}>
                                        <Grid item>
                                            <Link color="inherit" href="https://www.instagram.com/ultimatehomedesign/"
                                                  target="blank">
                                                <InstagramIcon
                                                    className={`${classes.topBarIcon} ${classes.instagram}`}/>
                                            </Link>
                                        </Grid>
                                        <Grid item>
                                            <Link color="inherit" href="https://www.facebook.com/Ultimatehomedesign"
                                                  target="blank">
                                                <FacebookIcon className={`${classes.topBarIcon} ${classes.facebook}`}/>
                                            </Link>
                                        </Grid>
                                        <Grid item>
                                            <Link color="inherit" href="https://www.pinterest.com/ultimatehomed"
                                                  target="blank">
                                                <PinterestIcon
                                                    className={`${classes.topBarIcon} ${classes.pinterest}`}/>
                                            </Link>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </div>
                </Hidden>

                {/* { Menu } */}
                <Grid container className={classes.container} style={{paddingTop: matchesSM ? "50px" : "20px"}}>
                    <Grid item container direction={matchesSM ? "column" : "row"} justify="space-between"
                          alignItems="center">
                        <Grid item>
                            <Grid item container direction="row" alignItems="center" spacing={2}>

                                <img src={logo} alt="Logo" className={classes.logoImage}/>

                                <Grid item>
                                    <Grid item container direction="column">
                                        <Grid item>
                                            <Typography component="h1" variant="h1"
                                                        style={{color: theme.palette.common.white}}
                                                        className={classes.logoTitle}>
                                                Techno Construction, LLC
                                            </Typography>
                                        </Grid>
                                        <Grid item>
                                            <Typography component="h1" variant="h2" style={{
                                                color: theme.palette.common.white,
                                                letterSpacing: "3px",
                                            }} className={classes.logoSubtitle}>
                                                A modern approach to your space planning
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>

                            </Grid>
                        </Grid>
                        <Grid item style={{paddingTop: matchesSM ? "50px" : null}}>
                            <Grid item container direction="row" alignItems="center" spacing={2}>
                                <Grid item component={Link} href={"/"} style={{textDecoration: "none"}}>
                                    <Typography variant="subtitle2"
                                                className={`${classes.menu} ` + `${classes.menuSelected}`}
                                                onClick={homeLink}>
                                        Home
                                    </Typography>
                                </Grid>
                                <Grid item component={Link} href={"/services"} style={{textDecoration: "none"}}>
                                    <Typography variant="subtitle2" className={classes.menu} onClick={servicesLink}>
                                        Services
                                    </Typography>
                                </Grid>
                                <Grid item component={Link} href={"/projects"} style={{textDecoration: "none"}}>
                                    <Typography variant="subtitle2" className={classes.menu} onClick={projectsLink}>
                                        Projects
                                    </Typography>
                                </Grid>
                                <Grid item component={Link} href={"/about"} style={{textDecoration: "none"}}>
                                    <Typography variant="subtitle2" className={classes.menu} onClick={aboutLink}>
                                        About
                                    </Typography>
                                </Grid>
                                <Grid item component={Link} href={"/contact"} style={{textDecoration: "none"}}>
                                    <Typography variant="subtitle2" className={classes.menu} onClick={contactLink}>
                                        Contact
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                {/* { Hero Text } */}
                <Grid container className={classes.container} style={{marginTop: matchesXS ? "0px" : matchesSM ? "25px" : matchesMD ? "50px" : "100px"}}>
                    <Grid item container direction="column" justify="center"
                          alignItems={matchesSM ? "center" : null} style={{height: "50vh", minHeight: '300px',}}>
                        <ScrollAnimation animateIn="slideInLeft" animateOnce={true}>
                            <Grid item>
                                <Typography component="h1" variant="h1" align={matchesSM ? "center" : "left"}
                                            gutterBottom className={classes.heroTitle}>
                                    Specializing in
                                </Typography>
                                <Typography component="h1" variant="h1" align={matchesSM ? "center" : "left"} paragraph
                                            className={classes.heroTitle}>
                                    Dental/Medical
                                </Typography>
                                <Typography component="h1" variant="h1" align={matchesSM ? "center" : "left"} paragraph
                                            className={classes.heroTitle}>
                                    Office Construction
                                </Typography>
                            </Grid>
                        </ScrollAnimation>

                        <ScrollAnimation animateIn="slideInLeft" animateOnce={true}>
                            <Grid item>
                                <Typography component="h1" variant="h2" align={matchesSM ? "center" : "left"}
                                            gutterBottom className={classes.heroSubtitle}>
                                    We will Work closely with Designing
                                </Typography>
                                <Typography component="h1" variant="h2" align={matchesSM ? "center" : "left"}
                                            className={classes.heroSubtitle}>
                                    every Detail of your project
                                </Typography>
                            </Grid>
                        </ScrollAnimation>
                    </Grid>
                </Grid>
            </div>
        </React.Fragment>

    );
}
